{
  "page_intro": "Every card and product: where it is sold, its condition, price and owner.",
  "empty": "No products match. Try other filters — or add a card.",
  "export_shopify": "Download for Shopify (CSV)",
  "no_photo": "No picture",
  "cert": "Cert",
  "consigned": "Consigned",
  "warnings_one": "{{count}} thing to fix",
  "warnings_other": "{{count}} things to fix",
  "condition": {
    "rank_missing": "Rank needed",
    "sealed": "Sealed (未開封)",
    "rank": "Rank {{rank}}"
  },
  "status": {
    "active": "On sale",
    "draft": "Draft",
    "archived": "Archived",
    "other": "Other"
  },
  "types": {
    "raw_single": "Card (raw)",
    "graded_single": "Graded card",
    "sealed_product": "Sealed product",
    "supplies": "Supplies"
  },
  "filters": {
    "q": "Search",
    "q_placeholder": "Name, product code, cert number",
    "status": "Status",
    "type": "Kind",
    "rank": "Rank",
    "game": "Game",
    "set": "Set",
    "set_placeholder": "Set code or name, e.g. SV2a",
    "price": "Price (tax incl.)",
    "stock": "Stock",
    "consigned": "Consigned",
    "has_media": "Has pictures",
    "tag": "Tag",
    "price_check": "Price check",
    "price_check_warn": "Check soon (yellow + red)",
    "price_check_alert": "Overdue (red)"
  },
  "stock": {
    "in_stock": "In stock",
    "sold_out": "Sold out",
    "unknown": "Not counted yet",
    "sold": "Sold",
    "held": "Reserved",
    "kinds_one": "{{n}} of {{count}} in stock",
    "kinds_other": "{{n}} of {{count}} in stock"
  },
  "price_check": {
    "today": "Today",
    "yesterday": "Yesterday",
    "days_ago_one": "{{count}} day ago",
    "days_ago_other": "{{count}} days ago",
    "check_soon": "Check soon",
    "overdue": "Overdue — check the price",
    "not_counted": "Not counted (sold or archived)",
    "checked_on": "Price checked {{date}}",
    "changed_on": "Price changed {{date}}",
    "editor_title": "Is the price still right?",
    "editor_line": "Price checked {{age}} ({{date}})",
    "still_right": "Price is still right",
    "still_right_saving": "Saving…",
    "save_first": "Save the new price first — saving it counts as a check.",
    "confirmed": "Price marked as checked",
    "hint": "Yellow after {{warn}} days, red after {{alert}} days without a check. Changing the price also counts as a check."
  },
  "channels": {
    "web": "Website",
    "none": "Not on the website"
  },
  "columns": {
    "image": "Picture",
    "title": "Name",
    "code": "Product code",
    "card": "Game / set / number",
    "condition": "Condition",
    "price": "Price (tax incl.)",
    "price_check": "Price checked",
    "stock": "Stock",
    "channels": "Sold on",
    "consigned": "Consignor",
    "status": "Status",
    "updated": "Last change"
  },
  "views": {
    "active": "On sale",
    "drafts": "Drafts",
    "consigned_draft": "Consigned, not on sale yet",
    "sold": "Sold, waiting to ship",
    "no_photos": "No pictures",
    "active_no_photos": "On sale without pictures",
    "prices_to_check": "Prices to check"
  },
  "bulk": {
    "publish": "Put on sale",
    "unpublish": "Take off sale",
    "add_tag": "Add tag",
    "tag_label": "Tag",
    "tag_add": "Add the tag",
    "add_collection": "Add to collection",
    "collection_label": "Find a collection",
    "collections_error": "Collections could not be loaded.",
    "collections_empty": "No hand-picked collection found.",
    "price": "Change price %",
    "archive": "Archive",
    "channels": "Send to marketplaces",
    "channels_later": "Marketplaces (eBay, Whatnot…) come in a later phase.",
    "partly": "{{ok}} done, {{failed}} could not be changed",
    "partly_hint": "Open the products marked “things to fix” to see why.",
    "unpublished_one": "{{count}} product taken off sale",
    "unpublished_other": "{{count}} products taken off sale",
    "published_one": "{{count}} product put on sale",
    "published_other": "{{count}} products put on sale",
    "tagged_one": "Tag “{{tag}}” added to {{count}} product",
    "tagged_other": "Tag “{{tag}}” added to {{count}} products",
    "collected_one": "{{count}} product added to “{{name}}”",
    "collected_other": "{{count}} products added to “{{name}}”",
    "priced_one": "Price changed for {{count}} product",
    "priced_other": "Prices changed for {{count}} products",
    "archived_one": "{{count}} product archived",
    "archived_other": "{{count}} products archived",
    "archive_title_one": "Archive {{count}} product?",
    "archive_title_other": "Archive {{count}} products?",
    "archive_consequence": "They leave the website and the register. You can bring them back later from the archived view.",
    "archive_confirm": "Archive",
    "price_title": "Change prices by a percentage",
    "price_consequence_empty_one": "Enter a percentage for {{count}} product.",
    "price_consequence_empty_other": "Enter a percentage for {{count}} products.",
    "price_consequence_up_one": "The price of {{count}} product goes up {{percent}} %, rounded to whole yen (tax incl.).",
    "price_consequence_up_other": "The prices of {{count}} products go up {{percent}} %, rounded to whole yen (tax incl.).",
    "price_consequence_down_one": "The price of {{count}} product goes down {{percent}} %, rounded to whole yen (tax incl.).",
    "price_consequence_down_other": "The prices of {{count}} products go down {{percent}} %, rounded to whole yen (tax incl.).",
    "price_percent": "Change by",
    "price_percent_hint": "Whole number from {{min}} to {{max}}, e.g. -10 for 10 % cheaper.",
    "price_reason_placeholder": "e.g. market price dropped, sale for the weekend",
    "price_confirm_one": "Change {{count}} price",
    "price_confirm_other": "Change {{count}} prices",
    "confirm_prices": "Mark prices as checked",
    "confirm_prices_title_one": "Mark the price of {{count}} card as checked?",
    "confirm_prices_title_other": "Mark the prices of {{count}} cards as checked?",
    "confirm_prices_consequence": "Their “price checked” days start again from today. The prices themselves do not change.",
    "confirm_prices_confirm": "Yes, the prices are right",
    "prices_confirmed_one": "Price marked as checked for {{count}} product",
    "prices_confirmed_other": "Prices marked as checked for {{count}} products"
  },
  "row": {
    "actions": "More for {{title}}",
    "duplicated": "Copy made as a draft",
    "view_on_web": "View on the website",
    "view_on_web_off": "View on the website (not on sale)",
    "duplicate": "Make a copy",
    "print_label": "Print a price label",
    "print_label_later": "Comes with the register's label printer"
  },
  "detail": {
    "not_found": "This product does not exist (or was removed)",
    "updated": "Last change",
    "pictures": "Pictures",
    "items": "Condition and price"
  },
  "quick": {
    "title": "Add a card",
    "intro": "4 short steps — about 2 minutes. What you type is kept on this device.",
    "progress_label": "Steps",
    "step_of": "Step {{n}} of {{total}}: {{name}}",
    "steps": {
      "card": "Card",
      "condition": "Condition",
      "pricing": "Price",
      "photos": "Pictures",
      "summary": "Check and save"
    },
    "headings": {
      "card": "Which card is it?",
      "condition": "What condition is it in?",
      "pricing": "Price, quantity and where it is",
      "photos": "Take or add pictures"
    },
    "next": "Next",
    "back": "Back",
    "publish": "Put it on sale now",
    "save_draft": "Save as draft",
    "card": {
      "label": "Which card?",
      "change": "Choose another card",
      "not_a_card": "It is a sealed box or pack, not one card",
      "free_title": "Name of the product",
      "free_title_hint": "For example: Pokémon 151 booster box (Japanese)",
      "back_to_list": "It is a card after all — choose from the card list",
      "cert_kept": "Graded card number {{cert}} is kept — now choose which card it is."
    },
    "condition": {
      "kind": "What is it?",
      "raw_single": "Card",
      "raw_single_hint": "A normal card — choose its Rank",
      "graded_single": "Graded card",
      "graded_single_hint": "In a slab (PSA, BGS, CGC …)",
      "sealed_product": "Sealed",
      "sealed_product_hint": "Box or pack, never opened",
      "rank_note": "Short note about the condition (optional)",
      "rank_note_hint": "For example: small scratch on the back. Customers see it.",
      "quantity": "How many",
      "weight": "Weight with the box (g)",
      "weight_hint": "For the postage — put the box on the scale",
      "box": "Box condition (optional)",
      "box_hint": "For example: shrink wrap intact, small dent on a corner"
    },
    "graded": {
      "company": "Grading company",
      "grade": "Grade",
      "psa_whole": "PSA gives whole grades only",
      "other": "Other",
      "label": "Label on the slab",
      "label_hint": "Filled in for you — change it if the slab says something else",
      "cert": "Certificate number",
      "cert_hint": "The number on the slab label (you can scan its barcode)",
      "cert_format": "This does not look like a usual {{company}} number — check it (you can still save).",
      "checking": "Checking…",
      "cert_taken": "This graded card is already in the shop: {{title}}",
      "open_existing": "Open it"
    },
    "pricing": {
      "price": "Selling price",
      "cost": "What the shop paid (optional)",
      "cost_hint": "Only staff see it — used for the margin",
      "tax_note": "Type the price including tax. The system works out the price without tax and the 10% tax when you save — you will see both.",
      "below_cost": "The price is lower than what the shop paid. That is allowed — just check it is on purpose.",
      "compare_at_on": "Show a reference price (was / list price)",
      "keihyo": "Japanese law (景品表示法) needs a real source for a reference price — without one it is not shown to customers.",
      "compare_at": "Reference price",
      "evidence": "Where does the reference price come from?",
      "evidence_own_price_history": "The shop really sold it at this price",
      "evidence_own_price_history_hint": "The system checks the price history (it must have been the price for long enough in the last 8 weeks).",
      "evidence_market_survey": "A price survey",
      "evidence_market_survey_hint": "Write how the prices were compared and when.",
      "evidence_msrp": "The maker's list price",
      "evidence_msrp_hint": "Only for sealed products — give the maker's page and the date.",
      "evidence_url": "Web page of the source",
      "evidence_date": "Date checked",
      "evidence_method": "How the prices were compared",
      "quantity": "Quantity",
      "quantity_locked": "One-of-a-kind card — always 1",
      "location": "Where it is kept"
    },
    "consignor": {
      "consigned": "This card belongs to a consignor (委託)",
      "label": "Whose card is it?",
      "placeholder": "Name or CON- number",
      "results": "Consignors",
      "verified": "ID checked (本人確認)",
      "not_verified": "ID check (本人確認) not done yet",
      "status": {
        "pending_verification": "Waiting for the ID check",
        "suspended": "Paused",
        "closed": "Closed"
      },
      "choose": "Choose",
      "fix": "Do it first",
      "change": "Change",
      "error": "Consignors could not be loaded.",
      "agreed": "Lowest price agreed with the consignor (optional)",
      "agreed_hint": "Price changes below this ask the consignor first",
      "commission": "Shop's commission (optional)",
      "commission_hint": "Empty = the consignor's usual rate",
      "discount": "Discounts allowed (at most {{max}}%)"
    },
    "photos": {
      "label": "Pictures of the card",
      "hint": "Take them with the phone camera or choose files. At least one picture is needed to put it on sale; a draft can be saved without.",
      "wait": "Pictures are still uploading — wait a moment."
    },
    "summary": {
      "title": "Title on the shop",
      "title_auto": "Made from the card automatically — change it if you like",
      "title_own": "Your own title",
      "card": "Card",
      "condition": "Condition",
      "price": "Price",
      "stock": "Stock",
      "photos": "Pictures",
      "change": "Change {{what}}",
      "tax_after": "Price without tax and the tax are shown after saving (worked out by the system).",
      "compare_at": "Reference price {{price}}",
      "cost": "Paid {{price}}",
      "stock_at_one": "{{count}} at {{where}}",
      "stock_at_other": "{{count}} at {{where}}",
      "consigned": "Consigned — {{name}}",
      "photo_count_one": "{{count}} picture",
      "photo_count_other": "{{count}} pictures",
      "no_photos": "No pictures yet (needed to put it on sale)"
    },
    "problems": {
      "card_required": "Choose the card (or \"sealed box\")",
      "title_required": "Write the name of the product",
      "rank_required": "Choose the card's condition A–D",
      "company_required": "Choose the grading company",
      "grade_required": "Choose the grade",
      "cert_required": "Type the certificate number",
      "cert_taken": "This certificate number is already in the shop",
      "quantity_invalid": "Use a whole number, 1 or more",
      "weight_required": "Type the weight in grams (1 or more)",
      "price_required": "Type the price in yen (1 or more)",
      "compare_at_required": "Type the reference price",
      "compare_at_not_higher": "The reference price must be higher than the price",
      "evidence_required": "Choose where the reference price comes from",
      "evidence_url_required": "Add the web page of the source",
      "evidence_date_required": "Add the date",
      "evidence_method_required": "Write how the prices were compared",
      "msrp_cards": "Cards have no maker's list price — choose another source",
      "location_required": "Choose where it is kept",
      "consignor_required": "Choose the consignor",
      "commission_invalid": "Use a number between 0 and 100",
      "photo_required": "Add at least one picture to put it on sale (or save as draft)"
    },
    "done": {
      "title": "Saved",
      "price": "Price (tax incl.)",
      "excl": "Without tax",
      "tax": "Consumption tax {{rate}}%",
      "toast_listed": "\"{{title}}\" is on sale",
      "toast_draft": "\"{{title}}\" saved as a draft",
      "not_listed": "Saved with its stock, but not put on sale yet:",
      "publish_problem": "Something is missing — open the card to see what",
      "next": "Add the next card",
      "same": "Same card again (new number, price, pictures)",
      "open": "Open the card"
    },
    "failure": {
      "nothing_saved": "Nothing was saved yet.",
      "product_after_save": "Nothing was saved yet.",
      "stock_after_save": "The card is saved as a draft, but its stock is not recorded yet. Press \"Try again\" — nothing is doubled.",
      "intake_after_save": "The consignment is recorded, but the card is not ready yet. Press \"Try again\".",
      "publish_after_save": "The card and its stock are saved, but it could not be put on sale.",
      "load_after_save": "Saved — the result could not be shown. Open the card.",
      "retry": "Try again",
      "open": "Open the saved card"
    }
  },
  "edit": {
    "jump": "Go to part",
    "short": {
      "1": "Card",
      "2": "Title",
      "3": "Condition",
      "4": "Price",
      "5": "Category",
      "6": "Pictures",
      "7": "Details",
      "8": "Consignment",
      "9": "Where sold",
      "10": "Search & status"
    },
    "sections": {
      "card": "Card",
      "title": "Title and description",
      "condition": "Condition",
      "pricing": "Price and stock",
      "tags": "Category and tags",
      "media": "Pictures",
      "details": "Details",
      "consignment": "Consignment",
      "channels": "Where it is sold",
      "seo": "Search engines and status"
    },
    "hints": {
      "card": "The card of the card catalog this product is.",
      "media": "The first picture is the main one. Drag to change the order."
    },
    "change_card": "Change the card",
    "keep_card": "Keep the current card",
    "no_card": "No card of the card catalog is linked.",
    "title": "Title",
    "title_required": "The title cannot be empty",
    "description": "Description",
    "description_hint": "A blank line starts a new paragraph.",
    "languages": "Title and description in the other languages",
    "rank_note": "Note about the condition",
    "saved_price": "Saved now:",
    "excl": "without tax",
    "tax": "tax {{rate}}%",
    "compare_at_verified": "Reference price checked",
    "compare_at_unverified": "Reference price not shown (no source yet)",
    "single_stock": "One-of-a-kind card: stock is 1 while it is in the shop.",
    "stock_hint": "Stock is changed in Inventory (receive / adjust with a reason).",
    "open_stock": "Open the stock",
    "category": "Category",
    "no_category": "No category",
    "vendor": "Maker",
    "tags": "Tags",
    "tags_hint": "Separate with commas, e.g. SAR, 151",
    "collections": "Collections chosen by hand",
    "no_collections": "No collections chosen by hand yet",
    "smart_matches": "Also in (by rules):",
    "read_only": "You can look but not change the pictures.",
    "detail_text": "More about this product",
    "detail_text_hint": "Shown on the product page under the description",
    "consigned": "This card belongs to a consignor.",
    "open_consignment": "Open the consigned card",
    "shop_own": "The shop's own card.",
    "channel_web": "Web shop",
    "channel_pos": "Shop register (POS)",
    "layout": "Page layout",
    "layout_hint": "Leave empty for the standard layout",
    "status": "Status",
    "publish_at": "Put on sale later (Japan time)",
    "publish_at_hint": "Leave empty to keep it as a draft",
    "trash": "Move to the trash",
    "trash_title": "Move this product to the trash?",
    "trash_body": "It is taken off the shop. Stock and history stay. You can put it back within 30 days.",
    "trashed": "Moved to the trash",
    "in_trash": "This product is in the trash.",
    "save": "Save",
    "saved": "Saved",
    "nothing_changed": "Nothing has changed",
    "fix_first": "Please fix the parts marked in red first",
    "rank_confirm_title": "Change the Rank of a card on sale?",
    "rank_confirm_body": "Customers see the new Rank at once. Write why (for the history).",
    "rank_confirm": "Change the Rank",
    "side_label": "Summary of this product",
    "side": {
      "status": "Now",
      "stock": "Stock per shop",
      "stock_error": "Stock could not be loaded",
      "no_stock": "No stock recorded",
      "available": "{{available}} available of {{onHand}}",
      "receive": "Receive stock",
      "price_history": "Price history",
      "no_history": "No changes yet",
      "changes": "Latest changes",
      "no_changes": "No changes recorded",
      "all_history": "See the whole history"
    }
  },
  "translations": {
    "tabs": "Languages",
    "locale": {
      "en": "English",
      "ja": "日本語",
      "th": "ไทย",
      "zh-Hant": "繁體中文",
      "zh-Hans": "简体中文"
    },
    "copy_all": "Copy from English to all languages",
    "copy_one": "Copy from English",
    "mark_checked": "I checked these",
    "suggest": "Suggest a translation",
    "empty_badge": "empty",
    "unchecked_badge": "check",
    "copied_mark": "Copied from English — not checked yet",
    "still_empty": "Still empty",
    "en_hint": "English is the main text — the other languages fall back to it.",
    "unchecked_count_one": "{{count}} copied text not checked yet",
    "unchecked_count_other": "{{count}} copied texts not checked yet"
  },
  "seo": {
    "heading": "Search engines",
    "preview": "How it looks on Google",
    "title": "Title on Google",
    "description": "Description on Google",
    "count": "{{count}} / {{max}}",
    "address": "Web address",
    "address_changed": "Old links keep working — they go to the new address."
  },
  "variants": {
    "name": "Choice (e.g. box / pack)",
    "name_n": "Name of choice {{n}}",
    "price": "Price (tax incl.)",
    "price_n": "Price of choice {{n}}",
    "cost": "Paid",
    "cost_n": "What the shop paid for choice {{n}}",
    "barcode": "Barcode (JAN)",
    "barcode_n": "Barcode of choice {{n}}",
    "weight": "Weight (g)",
    "weight_n": "Weight of choice {{n}}",
    "remove": "Remove",
    "remove_n": "Remove choice {{n}}",
    "add": "Add a choice",
    "excl": "without tax"
  },
  "attributes": {
    "list_hint": "One per line",
    "reference_hint": "The code of the linked item",
    "structured_hint": "Advanced — ask the owner before changing",
    "problems": {
      "required": "Please fill this in",
      "not_integer": "Use a whole number",
      "not_number": "Use a number",
      "below_min": "At least {{min}}",
      "above_max": "At most {{max}}",
      "too_long": "At most {{maxLength}} characters",
      "regex_mismatch": "The format does not fit",
      "not_in_choices": "Choose one of the options",
      "not_url": "Use a web address (https://…)",
      "not_date": "Choose a date",
      "not_structured": "This text is not in the expected form",
      "too_many_items": "At most {{maxItems}}"
    }
  },
  "trash": {
    "title": "Trash",
    "intro": "Products removed in the last {{days}} days. Put one back to use it again — stock and history are kept.",
    "empty": "The trash is empty",
    "days_left_one": "{{count}} day left",
    "days_left_other": "{{count}} days left",
    "restore": "Put back",
    "restored": "\"{{title}}\" is back as a draft"
  },
  "publish_issues": {
    "title_missing": "The title is missing",
    "price_missing": "The price is missing",
    "raw_rank_missing": "The Rank (A–D) is missing",
    "cert_missing": "The certificate number is missing",
    "category_missing": "The category is missing",
    "no_variant": "There is no price row",
    "compare_at_unverified": "The reference price has no source yet",
    "translation_ja_missing": "The Japanese title is missing",
    "other": "Something is missing ({{field}})"
  }
}
